/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Export_Preset_Delete_TextInputs */

const en_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"?`)
};

const fr_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous supprimer "${i?.name}" ?`)
};

const de_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen?`)
};

const it_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare "${i?.name}"?`)
};

const ru_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.name}"?`)
};

const es_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar "${i?.name}"?`)
};

const zh_cn2_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除“${i?.name}”吗？`)
};

const ja_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を削除してもよろしいですか?`)
};

const hi_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.name}" को हटाना चाहते हैं?`)
};

const pt_pt2_video_export_preset_delete_text = /** @type {(inputs: Video_Export_Preset_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.name}"?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"?" |
*
* @param {Video_Export_Preset_Delete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_delete_text = /** @type {((inputs: Video_Export_Preset_Delete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Delete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_delete_text(inputs)
	if (locale === "de") return de_video_export_preset_delete_text(inputs)
	if (locale === "it") return it_video_export_preset_delete_text(inputs)
	if (locale === "ru") return ru_video_export_preset_delete_text(inputs)
	if (locale === "es") return es_video_export_preset_delete_text(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_delete_text(inputs)
	if (locale === "ja") return ja_video_export_preset_delete_text(inputs)
	if (locale === "hi") return hi_video_export_preset_delete_text(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_delete_text(inputs)
	return en_video_export_preset_delete_text(inputs)
});